import React, { useState } from "react";
import { Entry } from "contentful";
import { BrandInvestmentFaq } from "@tiicker/util/lib/contentful/types";
import styles from "./FaqContainer.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/sharp-light-svg-icons";
import Markdown from "components/Markdown/Markdown";

type Props = {
  faqInfo: Entry<BrandInvestmentFaq>[];
};

const FaqContainer: React.FC<Props> = ({ faqInfo }) => {
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  if (!faqInfo) return null;

  const toggleItem = (id: string) => {
    setOpenItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className={styles.FaqContainer}>
      <h2 className={styles.FaqContainer__title}>FAQs</h2>
      <div className={styles.FaqContainer__items}>
        {faqInfo.map((faq) => {
          const isOpen = openItems[faq.sys.id];
          const { title, description, faqBoxHex, faqIconHex } = faq.fields;

          return (
            <div
              key={faq.sys.id}
              className={`${styles.FaqContainer__box} ${
                isOpen ? styles["FaqContainer__box--open"] : ""
              }`}
              style={{ borderColor: faqBoxHex }}
              onClick={() => toggleItem(faq.sys.id)}
            >
              <div className={styles.FaqContainer__header}>
                <h3 className={styles.FaqContainer__question}>{title}</h3>
                <FontAwesomeIcon
                  icon={isOpen ? faMinus : faPlus}
                  className={styles.FaqContainer__icon}
                  style={{ color: faqIconHex }}
                />
              </div>
              <div
                className={`${styles.FaqContainer__content} ${
                  isOpen ? styles["FaqContainer__content--visible"] : ""
                }`}
              >
                {/*<p className={styles.FaqContainer__answer}>{description}</p>*/}
                <Markdown
                  markdownText={description}
                  className={styles.FaqContainer__answer}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FaqContainer;
